import { BrandMark } from './BrandMark';

export function ReaderFooter() {
  return (
    <footer className="reader-footer">
      <div className="reader-footer-brand">
        <BrandMark width={14} muted />
        <span>© {new Date().getFullYear()} TLDR</span>
      </div>
      <div className="reader-footer-links">
        <a href="/newsletters">Newsletters</a>
        <a href="/advertise">Advertise</a>
        <a href="/blog">Blog</a>
      </div>
    </footer>
  );
}
